<mat-form-field appearance="fill" class="full-width">
  <mat-label>Select portfolio rights</mat-label>
  <mat-select
    [formControl]="selectListControl"
    [multiple]="true"
    (selectionChange)="typeChangeAction($event)"
    >
    @for (right of portfolio_rights; track right) {
      <mat-option [value]="right">
        {{ right }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
